// import i18next from 'i18next'

export const connectionStatus = (serviceUrl) => (dispatch) => {
    var readyStateChanged, baseUrl, url, xhr, reponseStatus;

    url = serviceUrl + "/api/v1"

    xhr = new XMLHttpRequest();
    xhr.open("GET", url + "/status");
    xhr.setRequestHeader("Content-type", "application/json");

    readyStateChanged = function () {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                reponseStatus = true;
                baseUrl = url
            } else {
                baseUrl = null
                reponseStatus = false;
            }
            dispatch({
              type: 'CONNECTION_STATUS',
              payload: {reponseStatus, baseUrl}
            })
        }
    };

    readyStateChanged = readyStateChanged.bind(this);
    xhr.onreadystatechange = readyStateChanged;

    xhr.send();
}

export const featuresStatus = (url) => (dispatch) => {

    return fetch(url + "/api/v1/features", {
        method: 'GET',
        dataType: "json"
      }).then(response => {
        if(response.ok) {
          return response.json()
        }
      }).catch(function() {
          return false
      })
}

export const cloudConnectionStatus = (url) => (dispatch) => {

    return fetch(url + "/api/v1/status", {
        method: 'GET',
        dataType: "json"
      }).then(response => {
        if(response.ok) {
          return true
        }
      }).catch(function() {
          return false
      })
}

export const getURLs = () => (dispatch) => {
    return fetch(process.env.PUBLIC_URL + "/config.json", {
        method: 'GET',
        dataType: "json"
      }).then(response => {
        return response.json()
    });
}

export const getVersion = () => (dispatch) => {

    return fetch(process.env.PUBLIC_URL + "/version.json", {
        method: 'GET',
        dataType: "json"
      }).then(response => {
        return response.json()
    });
}

export const getJNLP = () => (dispatch) => {
    return fetch(process.env.PUBLIC_URL + "/jnlp", {
        method: 'GET'
      }).then(response => {
        console.log(response.url)
        // response.text()
        return response.url
    });
}

export const createSession = (url) => (dispatch) => {
    var requestUrl;
        
    requestUrl = url + "/ticket/"

    return fetch(requestUrl, {
        method: 'POST',
        dataType: "json"
      }).then(response => {
        return response.json()
        
    });
}

export const sendInputData = (url, uuid, inputData) => (dispatch) => {
    var requestUrl;
        
    requestUrl = url + "/ticket/" + uuid + "/data"

    return fetch(requestUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/octet-stream'
        },
        body: inputData
      }).then((response) => {
        response.json().then((response) => {
          console.log(response);
          return(response)
        });
    });
}

export const sendEncryptTextData = (url, uuid, inputData) => (dispatch) => {
    var requestUrl;
        
    requestUrl = url + "/ticket/" + uuid + "/data"

    return fetch(requestUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/octet-stream'
        },
        body: inputData
      }).then((response) => {
        response.json().then((response) => {
          console.log(response);
          return(response)
        });
    });
}

export const sendDSData = (url, uuid, inputDSData) => (dispatch) => {
    var requestUrl;
        
    requestUrl = url + "/ticket/" + uuid + "/ds/data"
    
    return fetch(requestUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/octet-stream'
        },
        body: inputDSData
      }).then((response) => {
        response.json().then((response) => {
          console.log(response);
          return(response)
        });
    });
}

export const sendTSData = (url, uuid, inputTSData) => (dispatch) => {
    var requestUrl;
        
    requestUrl = url + "/ticket/" + uuid + "/ts/data"
    
    return fetch(requestUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/octet-stream'
        },
        body: inputTSData
      }).then((response) => {
        response.json().then((response) => {
          console.log(response);
          return(response)
        });
    });
}

export const sendSessionOption = (url, uuid, options) => (dispatch) => {

    var selectedOptions, requestUrl;
      selectedOptions = options

    requestUrl = url + "/ticket/" + uuid + "/option";
      return fetch(requestUrl, {
        method: 'PUT',
        dataType: "json",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(selectedOptions)
      }).then((response) => {
        response.json().then((response) => {
          console.log(response);
          return(response)
        });
    });
}

export const getADUserInfo = (url, login, password) => (dispatch) => {
    var userPassword, requestUrl;
      userPassword = {
        user: login,
        password: password
      }

    requestUrl = url + "/handyman/api/v1/ad/user";
      return fetch(requestUrl, {
            method: 'PUT',
            dataType: "json",
            headers: {
                'Access-Control-Allow-Origin':"*",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(userPassword)
        }).then((response) => {
        console.log(response)
        if (response.ok) {
            console.log(response);
            return response.json()
        } else {
            return null
        }
    });
}

export const openFileDialog = (url) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ui/keyContainerChooser";
      return fetch(requestUrl, {
        method: 'PUT',
        dataType: "json"
      }).then((response) => {
        console.log(response)
        if (response.ok) {
            console.log(response);
            return response.json()
        } else {
            return null
        }
    });
}

export const sendTokenPath = (url, uuid, path) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/keyStore";
      return fetch(requestUrl, {
        method: 'PUT',
        dataType: "json",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(path)
      }).then((response) => {
          console.log(response);
          return response.json()
    });
}

export const verifyDSData = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/ds/verifier"
      return fetch(requestUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'text/plain'
        }
      }).then((response) => {
        response.json().then((response) => {
          console.log(response);
          return(response)
        });
    });
}

export const verifyTSData = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/ts/verifier"
      return fetch(requestUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'text/plain'
        }
      }).then((response) => {
        response.json().then((response) => {
          console.log(response);
          return(response)
        });
    });
}

export const verifyTSResult = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/ts/verifier"
      return fetch(requestUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
      }).then((response) => {
        return response.json()
    });
}

export const getConnecteds = (url) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/token/connected"
      return fetch(requestUrl, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      }).then((response) => {
        return response.json()
    });
}

export const getKeysProfiles = (url) => (dispatch) => {
    var requestUrl, message;

    requestUrl = url + "/generator/keysProfiles"
      return fetch(requestUrl, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      }).then((response) => {
        if(response.ok) {
          return response.json()
        } else {
          try {
              var jsonResponse = JSON.parse(response.responseText);
              message = jsonResponse.message;
          } catch (e) {
              message = (jsonResponse.responseText === undefined) ? "Ошибка при получении дынных сертификата ЕКЦ." : response.responseText;
          }
          console.log(message)
          return null
        }
    });
}

export const generateNewKeys = (url, data) => (dispatch) => {
    var requestUrl, message, keyGenerationData;

    keyGenerationData = data;

    requestUrl = url + "/generator/creator"
      return fetch(requestUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(keyGenerationData)
      }).then((response) => {
        if(response.ok) {
          return response.json()
        } else {
          try {
              var jsonResponse = JSON.parse(response.responseText);
              message = jsonResponse.message;
          } catch (e) {
              message = (jsonResponse.responseText === undefined) ? "Ошибка при получении дынных сертификата ЕКЦ." : response.responseText;
          }
          console.log(message)
          return null
        }
    });
}

export const getVerifiedData = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/ds/verifier"
      return fetch(requestUrl, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      }).then((response) => {
        return response.json()
    });
}

export const getSignedData = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/ds/signedData";
      return fetch(requestUrl, {
      method: 'GET',
      dataType: "blob",
      headers: {
        'Content-Type': 'application/octet-stream'
      }
    }).then((response) => {
      if(response.ok) {
        return response.blob()
      } else {
        return null
      }
    });
}

export const sendSessionMetaData = (url, uuid, metaData) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/metadata"
      return fetch(requestUrl, {
        method: 'put',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({metaData: metaData})
      }).then((response) => {
        response.json().then((response) => {
          console.log(response);
          return(response)
        });
    });
}

export const createDS = (url, uuid) => (dispatch) => {
    var requestUrl;
    requestUrl = url + "/ticket/" + uuid + "/ds/creator"

    return fetch(requestUrl, {
      method: 'POST',
      dataType: "json",
      headers: {
            'Content-Type': 'text/plain'
      }
    }).then((response) => {
      response.json().then((response) => {
        console.log(response);
        return(response)
      });
    });
}

export const createTS = (url, uuid) => (dispatch) => {
    var requestUrl;
    requestUrl = url + "/ticket/" + uuid + "/ts/creator"

    return fetch(requestUrl, {
      method: 'POST',
      dataType: "json",
      headers: {
            'Content-Type': 'text/plain'
      }
    }).then((response) => {
      response.json().then((response) => {
        console.log(response);
        return(response)
      });
    });
}

export const getDSResult = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/ds/data"
    return fetch(requestUrl, {
      method: 'GET',
      dataType: "blob",
      headers: {
        'Content-Type': 'application/octet-stream'
      }
    }).then((response) => {
      console.log(response)
      if (response.ok) {
        return response.blob()
      } else {
        return null
      }
    });
}

export const getTSResult = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/ts/data"
    return fetch(requestUrl, {
      method: 'GET',
      dataType: "blob",
      headers: {
        'Content-Type': 'application/octet-stream'
      }
    }).then((response) => {
      console.log(response)
      if (response.ok) {
        return response.blob()
      } else {
        return null
      }
    });
}

export const getDSStatus = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/ds/creator"
    return fetch(requestUrl, {
      method: 'GET',
      dataType: "json",
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
        console.log(response);
        return response.json()
    });
}

export const getTSStatus = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/ts/creator"
    return fetch(requestUrl, {
      method: 'GET',
      dataType: "json",
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
        console.log(response);
        return response.json()
    });
}

export const getSupportedCA = (url) => (dispatch) => {

    return fetch(url + "/certificateAuthority/supported", {
        method: 'GET'
      }).then((response) => {
          return response.json()
    });
}

export const sendKeyContainer = (url, uuid, keyContainer) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/keyStore"

    return fetch(requestUrl, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/octet-stream'
        },
        body: keyContainer
      }).then((response) => {
        response.json().then((response) => {
          console.log(response);
          return(response)
        });
    });
}

export const getKCInfo = (url, uuid, pass) => (dispatch) => {
    var requestUrl, message, failureCause;

    requestUrl = url + "/ticket/" + uuid + "/keyStore/verifier"

    return fetch(requestUrl, {
        method: 'PUT',
        dataType: "json",
        headers: {
              'Content-Type': 'application/json'
        },
        body: JSON.stringify({"keyStorePassword": pass})
    }).then((response) => {
        if (response.ok) {
          message = (response.responseText === undefined) ? "Данные сертификата ключа ЕКЦ получены." : response.responseText;
          console.log(message)
          return response.json()
        } else {
          try {
              var jsonResponse = JSON.parse(response.responseText);
              message = jsonResponse.message;
              failureCause = jsonResponse.failureCause;
              console.log(failureCause)
          } catch (e) {
              message = (response.responseText === undefined) ? "Ошибка при проверке ключевого контейнера." : response.responseText;
              console.log(message)
          }
          return response.json()
        }
    });
}

export const getCertificateInfoSignature = (url) => (dispatch) => {
    var requestUrl, message;

    requestUrl = url + "/certificateInfo/signature"

    return fetch(requestUrl, {
        method: 'GET',
        dataType: "json",
        headers: {
              'Content-Type': 'application/json'
        }
    }).then((response) => {
        if(response.ok) {
          message = (response.responseText === undefined) ? "Данные сертификата ключа ЕКЦ получены." : response.responseText;
          console.log(message)
          return response.json()
        } else {
          try {
              var jsonResponse = JSON.parse(response.responseText);
              message = jsonResponse.message;
          } catch (e) {
              message = (response.responseText === undefined) ? "Ошибка при получении дынных сертификата ЕКЦ." : response.responseText;
          }
          console.log(message)
          return null
        }
    });
}

export const getCertificateInfoKeyAgreement = (url, uuid) => (dispatch) => {
    var requestUrl, message;

    requestUrl = url + "/certificateInfo/keyAgreement"

    return fetch(requestUrl, {
        method: 'GET',
        dataType: "json",
        headers: {
              'Content-Type': 'application/json'
        }
    }).then((response) => {
        if(response.ok) {
          message = (response.responseText === undefined) ? "Данные сертификата ключа шифрования получены." : response.responseText;
          console.log(message)
          return response.json()
        } else {
          try {
              var jsonResponse = JSON.parse(response.responseText);
              message = jsonResponse.message;
          } catch (e) {
              message = (response.responseText === undefined) ? "Ошибка при получении дынных сертификата ключа шифрования." : response.responseText;
          }
          console.log(message)
          return null
        }
    });
}

export const sendCertificate = (url, uuid, data) => (dispatch) => {
    var requestUrl;

    var dataToSend = {
        recipientCertificates: [data]
    }

    requestUrl = url + "/ticket/" + uuid + "/encryptor/certificates"

    return fetch(requestUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      }).then((response) => {
        response.json().then((response) => {
          console.log(response);
        });
    });
}

export const encryptData = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/encryptor"

    return fetch(requestUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'text/plain'
        }
      }).then((response) => {
        response.json().then((response) => {
          console.log(response);
        });
    });
}

export const encryptTextData = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/encryptor"

    return fetch(requestUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
      }).then((response) => {
        response.json().then((response) => {
          console.log(response);
        });
    });
}

export const getEncryptorStatus = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/encryptor"
    return fetch(requestUrl, {
      method: 'GET',
      dataType: "json",
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
        console.log(response);
        return response.json()
    });
}

export const getEncryptTextData = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/encryptor/base64Data"

    return fetch(requestUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
      }).then((response) => {
          console.log(response);
          return response.json()
    });
}

export const getDecryptTextData = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/decryptor/base64Data"

    return fetch(requestUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
      }).then((response) => {
          console.log(response);
          return response.json()
    });
}

export const decryptData = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/decryptor"

    return fetch(requestUrl, {
        method: 'POST',
        dataType: "json",
        headers: {
            'Content-Type': 'text/plain'
        }
      }).then((response) => {
        response.json().then((response) => {
          console.log(response);
        });
    });
}

export const getDecryptorStatus = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/decryptor"
    return fetch(requestUrl, {
      method: 'GET',
      dataType: "json",
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
        console.log(response);
        return response.json()
    });
}

export const getCertificateInBase64 = (url, keyType) => (dispatch) => {
    var requestUrl;
    requestUrl = url + "/certificate/base64/" + keyType
    return fetch(requestUrl, {
      method: 'GET',
      dataType: "json",
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if(response.ok) {
        return response.json()
      } else {
        return null
      }
    });
}

export const getEncryptedData = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/encryptor/data"
    return fetch(requestUrl, {
      method: 'GET',
      dataType: "blob",
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      console.log(response)
      if(response.ok) {
        return response.blob()
      } else {
        return null
      }
    });
}

export const getDecryptedData = (url, uuid) => (dispatch) => {
    var requestUrl;

    requestUrl = url + "/ticket/" + uuid + "/decryptor/data"
    return fetch(requestUrl, {
      method: 'GET',
      dataType: "blob",
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      console.log(response)
      if(response.ok) {
        return response.blob()
      } else {
        return null
      }
    });
}

export const deleteSession = (url, uuid) => (dispatch) => {

    return fetch(url + "/ticket/" + uuid, {
      method: "DELETE",
      dataType: "json",
      cache: "no-cache",
    }).then((response) => {
        response.json().then((response) => {
            console.log(response);
        });
    });
}

export const changeServiceLanguage = (url, lng) => (dispatch) => {
  console.log(lng);
    return fetch(url + "/language/" + lng, {
      method: "POST",
      dataType: "json"
    }).then((response) => {
        response.json().then((response) => {
            console.log(response);
        });
    });
}


// WEBPACK FOOTER //
// ./src/actions/api/index.js